// FassalkartAI - Full-page Loading Screen

import React, { useState, useEffect } from 'react';
import { Box, Typography, LinearProgress } from '@mui/material';

const FACTS = [
  'India has over 140 million farmers cultivating 170 million hectares.',
  'Wheat and rice together cover more than 50% of India\'s sown area.',
  'Soil testing before sowing can increase yield by up to 20%.',
  'Drip irrigation saves up to 50% water compared to flood irrigation.',
  'Organic matter improves soil structure, water retention, and fertility.',
  'Crop rotation breaks pest cycles and replenishes soil nutrients naturally.',
  'India is the world\'s largest producer of spices and pulses.',
  'Integrated Pest Management reduces pesticide use by up to 40%.',
];

const LoadingScreen = ({ message = 'Loading FassalkartAI...' }) => {
  const [progress, setProgress] = useState(0);
  const [fact] = useState(() => FACTS[Math.floor(Math.random() * FACTS.length)]);

  useEffect(() => {
    const timer = setInterval(() => {
      setProgress(p => (p >= 95 ? 95 : p + Math.random() * 15));
    }, 300);
    return () => clearInterval(timer);
  }, []);

  return (
    <Box sx={{
      position: 'fixed', inset: 0,
      bgcolor: 'background.default',
      display: 'flex', flexDirection: 'column',
      alignItems: 'center', justifyContent: 'center',
      zIndex: 9999, gap: 3,
    }}>
      {/* Animated Logo */}
      <Box
        component="img"
        src="/logo192.png"
        alt="FassalkartAI"
        sx={{
          width: 80,
          height: 80,
          objectFit: 'contain',
          animation: 'pulse 1.5s ease-in-out infinite',
          '@keyframes pulse': {
            '0%, 100%': { transform: 'scale(1)', opacity: 1 },
            '50%': { transform: 'scale(1.12)', opacity: 0.8 },
          },
        }}
      />

      <Typography variant="h5" fontWeight={700} color="primary">FassalkartAI</Typography>
      <Typography variant="body2" color="text.secondary">{message}</Typography>

      {/* Progress Bar */}
      <Box sx={{ width: 280 }}>
        <LinearProgress
          variant="determinate"
          value={progress}
          sx={{ height: 4, borderRadius: 2, bgcolor: 'rgba(46,125,50,0.15)', '& .MuiLinearProgress-bar': { borderRadius: 2 } }}
        />
      </Box>

      {/* Agri Fact */}
      <Box sx={{ maxWidth: 360, textAlign: 'center', px: 2, mt: 1 }}>
        <Typography variant="caption" color="text.secondary" fontStyle="italic">
          💡 {fact}
        </Typography>
      </Box>
    </Box>
  );
};

export default LoadingScreen;
